import axios from 'axios'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const FEATURE_FLAG_URL = `${ROOT}/tools/feature-flags`

export function getFeatureFlags() {
  return axios.get(FEATURE_FLAG_URL)
}
